import { AutogenLayoutStopAppointmentStatusList } from "./autogen/AutogenLayoutStopAppointmentStatusList";
import { getDetentionControlBoolean } from "@mcleod/general";

export class StopAppointmentStatusList extends AutogenLayoutStopAppointmentStatusList {
    
    private showDetention = getDetentionControlBoolean("is_active", false);
    
    onLoad(): void | Promise<void> {
        if (!this.showDetention) {
            this.tableStopApptStatusList.removeColumn("columnHeaderAuthStatus");
        }
    }
}
